import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AsideMenuComponent } from './aside-menu/aside-menu.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { FooterComponent } from './footer/footer.component';
import { NavButtonComponent } from './navbar/components/nav-button/nav-button.component';
import { NavUserComponent } from './navbar/components/nav-user/nav-user.component';
import { NavbarComponent } from './navbar/navbar.component';
import { TitleHrComponent } from './title-hr/title-hr.component';

//! Prime ng
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { SpinnerLoadingComponent } from './spinner-loading/spinner-loading.component';
//icons
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import {
  faBell as farBell,
  faCalendar as farCalendar,
  faEnvelope as farEnvelope,
  faPenToSquare as farPenToSquare,
} from '@fortawesome/free-regular-svg-icons';
import {
  faAngleDown,
  faAngleLeft,
  faAnglesRight as faAngleRight,
  faAngleUp,
  faAnglesLeft,
  faAngleRight as faAnglesRight,
  faClipboard,
  faThumbTack,
  faHome as fasHome,
  faList as fasList,
} from '@fortawesome/free-solid-svg-icons';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { DirectivesModule } from '../directives/directives.module';
import { GenerateLodBlockComponent } from '../generate-lod-block/generate-lod-block.component';
import { AddButtonComponent } from './add-button/add-button.component';
import { PermissionButtonComponent } from './permission-button/permission-button.component';

import { ImageCropperModule } from 'ngx-image-cropper';
import { AccordionModule } from 'primeng/accordion';
import { CarouselModule } from 'primeng/carousel';
import { DividerModule } from 'primeng/divider';
import { SelectButtonModule } from 'primeng/selectbutton';
import { GoalCardComponent } from '../pages/home/components/cards/goal-card/goal-card.component';
import { AgendaComponent } from './agenda/agenda.component';
import { CalendarioComponent } from './agenda/calendario/calendario.component';
import { ItemAgendaMinComponent } from './agenda/calendario/item-agenda/item-agenda.component';
import { BackButtonQualityComponent } from './back-button-quality/back-button-quality.component';
import { ButtonComponent } from './button/button.component';
import { DialogComponent } from './dialog/dialog.component';
import { EditionsTableComponent } from './editions-table/editions-table.component';
import { FaqButtonComponent } from './faq/faq.component';
import { FileImportComponent } from './file-import/file-import.component';
import { RowComponent } from './file-import/rows/rows.component';
import { InputPasswordComponent } from './input-password/input-password.component';
import { ItemAgendaComponent } from './navbar/components/item-agenda/item-agenda.component';
import { NotificacionesComponent } from './notificaciones/notificaciones.component';
import { PdfButtonComponent } from './pdf-button/pdf-button.component';
import { PoliciesComponent } from './policies/policies.component';
import { RenderViewComponent } from './render-view/render-view.component';
import { RenderComponent } from './render-view/render/render.component';
import { SelectPermissionsComponent } from './select-permissions/select-permissions.component';
import { ShowHideSharedComponent } from './show-hide/show-hide.component';
import { SpinnerLoadingExcelComponent } from './spinner-loading-excel/spinner-loading-excel.component';
import { SpinnerLoadingPdfComponent } from './spinner-loading-pdf/spinner-loading-pdf.component';
import { StatsKmShellGraphComponent } from './stats-km-shell-graph/stats-km-shell-graph.component';
import { StatsKmShellComponent } from './stats-km-shell/stats-km-shell.component';
import { SubtitleHrComponent } from './subtitle-hr/subtitle-hr.component';
import { TopBottomButtonComponent } from './top-bottom-button/top-bottom-button.component';
import { TitleGeneralComponent } from './title-quality/title-general.component';

@NgModule({
  declarations: [
    NavButtonComponent,
    ShowHideSharedComponent,
    NavUserComponent,
    NavbarComponent,
    AsideMenuComponent,
    FooterComponent,
    TitleHrComponent,
    SpinnerLoadingComponent,
    SpinnerLoadingPdfComponent,
    SpinnerLoadingExcelComponent,
    BackButtonComponent,
    DialogComponent,
    ButtonComponent,
    PdfButtonComponent,
    SubtitleHrComponent,
    TopBottomButtonComponent,
    AddButtonComponent,
    PermissionButtonComponent,
    NotificacionesComponent,
    ItemAgendaComponent,
    AgendaComponent,
    CalendarioComponent,
    ItemAgendaMinComponent,
    InputPasswordComponent,
    PoliciesComponent,
    FileImportComponent,
    RowComponent,
    FaqButtonComponent,
    RenderViewComponent,
    RenderComponent,
    StatsKmShellComponent,
    StatsKmShellGraphComponent,
    SelectPermissionsComponent,
    EditionsTableComponent,
    GoalCardComponent,
    BackButtonQualityComponent,
    TitleGeneralComponent


  ],
  imports: [
    CommonModule,
    TableModule,
    FormsModule,
    ProgressSpinnerModule,
    FontAwesomeModule,
    PaginatorModule,
    ToastModule,
    ConfirmDialogModule,
    GenerateLodBlockComponent,
    DirectivesModule,
    RouterModule,
    DialogModule,
    TooltipModule,
    InputTextModule,
    InputTextareaModule,
    CalendarModule,
    ColorPickerModule,
    CheckboxModule,
    SelectButtonModule,
    AccordionModule,
    DividerModule,
    CarouselModule,
    ImageCropperModule,


  ],
  exports: [
    AsideMenuComponent,
    TitleHrComponent,
    FooterComponent,
    BackButtonComponent,
    NavbarComponent,
    SpinnerLoadingComponent,
    DialogComponent,
    ButtonComponent,
    PdfButtonComponent,
    SubtitleHrComponent,
    TopBottomButtonComponent,
    AddButtonComponent,
    PermissionButtonComponent,
    StatsKmShellComponent,
    ShowHideSharedComponent,
    InputPasswordComponent,
    PoliciesComponent,
    FileImportComponent,
    FaqButtonComponent,
    StatsKmShellGraphComponent,
    RenderViewComponent,
    SelectPermissionsComponent,
    EditionsTableComponent,
    BackButtonQualityComponent,
    TitleGeneralComponent,


  ],
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faAngleLeft,
      faAngleRight,
      farCalendar,
      farEnvelope,
      farPenToSquare,
      farBell,
      faAnglesLeft,
      fasList,
      faAnglesRight,
      fasHome,
      faAngleUp,
      faAngleDown,
      faClipboard,
      faThumbTack
    );
  }
}
